import AdvertH from "../../images/AdvertH.webp"
const AdvertHero = () => {
  return (
    <div className="flex flex-col items-center    gap-16 w-full h-[816px]  top-[120px] bg-[#101928] overflow-hidden ">
      {/* Frame 2147228667 */}
      <div className="flex flex-col items-center gap-8 w-[1019px] h-[172px] flex-none flex-grow-0">
        {/* Frame 2147228666 */}
        <div className="flex flex-col items-center gap-4 w-[1019px] h-[172px] flex-none flex-grow-0">
          {/* Heading */}
          <h1 className=" h-[114px] pt-24 font-medium leading-[100%] text-[48px]  text-center text-white ">
            Tap into the core of the <span className="text-[#0D924F]"> Sustainability<bri/> Economy.</span>
          </h1>
          
          {/* Subtitle */}
          <p className="w-[841px] h-[42px] pt-20 font-normal text-[18px] leading-[21px] text-center text-[#B1B1B1] flex-none self-stretch flex-grow-0">
            CloseCarbon offers high-visibility advertisement slots and sponsored content opportunities for brands looking to engage with verified corporate offsetters.
          </p>
        </div>
      </div>

      {/* Image */}
      <img src={AdvertH} className=" pt-[120px]  object-cover rounded-t-xl ">
        {/* You can add alt text or additional content here if needed */}
      </img>
    </div>
  );
};

export default AdvertHero;